import { COUNTRY_SUMMARY_ITEM } from '../../../../components/SummaryList/SummaryItems/base';
import { WINDOW_FORMATION_SUMMARY_ITEM } from '../../../../components/SummaryList/SummaryItems/formation';

export default [WINDOW_FORMATION_SUMMARY_ITEM, COUNTRY_SUMMARY_ITEM];
